import React, { Suspense } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useBreakpoints } from 'hooks/useWindowSize';
import { Modal } from 'shared/components/Modal/Modal';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import { Button } from 'shared/components/Button/Button';
import {
  CardText,
  CardTitle,
  TpvBaseContainer,
  TpvModalContent,
  TpvModalFooter,
} from './TpvUnavailableModal.styles';
import { pages } from '../../../../pages';

const TpvUnavailableGraphic = React.lazy(
  () => import('shared/components/icons/CallSupportGraphic'),
);

export type TpvModalProps = {
  isOpen: boolean;
  onCloseModal: () => void;
};

export function TpvUnavailableModal({ isOpen, onCloseModal }: TpvModalProps) {
  const { t } = useTranslation();
  const screenSize = useBreakpoints();

  const navigate = useNavigate();

  const handleStartCallClick = () => {
    navigate(`/${pages.SUPPORT}`);
  };

  return (
    <Modal
      contentLabel={t('tpvUnavailableModal.title')}
      styleVariant="tertiary"
      isOpen={isOpen}
      subHeader
      isFullWidth={screenSize === 'sm'}
      isFullHeight={screenSize === 'sm'}
      fitContent
      padding="24px"
      onRequestClose={onCloseModal}
    >
      <TpvBaseContainer>
        <TpvModalContent>
          <Suspense fallback={<LoadingSpinner />}>
            <TpvUnavailableGraphic />
          </Suspense>
          <CardTitle as="h2">{t('tpvUnavailableModal.title')}</CardTitle>
          <CardText as="p">
            <Trans defaults="tpvUnavailableModal.body" />
          </CardText>
          <table>
            <tbody>
              <tr>
                <td>{t('tpvUnavailableModal.weekdays')}</td>
                <td>{t('tpvAgentHoursWeekdays')}</td>
              </tr>
              <tr>
                <td>{t('tpvUnavailableModal.saturday')}</td>
                <td>{t('tpvAgentHoursSaturday')}</td>
              </tr>
              <tr>
                <td>{t('tpvUnavailableModal.sunday')}</td>
                <td>{t('tpvAgentHoursSunday')}</td>
              </tr>
            </tbody>
          </table>
        </TpvModalContent>
        <TpvModalFooter>
          <Button
            label={t('tpvUnavailableModal.closeButton')}
            styleVariant="tertiary"
            onClick={onCloseModal}
          />
          <Button
            label={t('tpvUnavailableModal.contactSupportButton')}
            onClick={handleStartCallClick}
          />
        </TpvModalFooter>
      </TpvBaseContainer>
    </Modal>
  );
}

export default TpvUnavailableModal;
